import { SnackTheme } from '@main/snackbar/const';

export interface OccInfoblocksResponse {
  infoblocks: OccInfoblock[];
}

export interface OccInfoblock extends Omit<Infoblock, 'startTime' | 'endTime'> {
  startTime: string;
  endTime: string;
}

export interface InfoblockButton {
  type: InfoblockButtonTypes;
  label: string;
  link?: string;
  promoCode?: string;
}

export interface PageMeta {
  uid?: string;
  categoryCode?: string;
}
export interface Infoblock {
  code: string;
  startTime: Date;
  endTime: Date;
  title: string;
  text: string;
  theme: SnackTheme;
  includedPages: PageMeta[];
  excludedPages: PageMeta[];
  button?: InfoblockButton;
}

export enum InfoblockButtonTypes {
  STANDARD = 'STANDARD',
  PROMOCODE = 'PROMOCODE',
  MULTIPROMOCODE = 'MULTIPROMOCODE',
}
